export const invoiceStatuses = [
  'canceled',
  'approved',
  'paid',
  'overdue',
  'new',
  'skipped',
] as const;
export type TInvoiceStatus = (typeof invoiceStatuses)[number];
